export const PATH = Object.freeze({
  AKTZIN: '/aktzin',
  QR_SCANNER: '/qr-scanner',
  EVSES: '/evses',
  CHARGING_RECORDS: '/charging_records',
  ERROR: '/error',
  TERMS: '/terms',
  PRIVACY: '/privacy',
});

const deployEnv = process.env.REACT_APP_DEPLOY_ENV === 'prod' ? 'prod' : 'alpha';
export const isAlpha = deployEnv === 'alpha';

const ALPHA_API_URL = 'https://api-alpha.pickncharge.xyz';
//const ALPHA_API_URL = 'http://api.localhost:5002'; // 本地開發後端
const PROD_API_URL = 'https://api.pickncharge.xyz';
const ALPHA_AMPLITUDE_KEY = '49ee79f9b32e96141c5e8866b31d5cc1';
const PROD_AMPLITUDE_KEY = '125bfc75448a4a41133c5c6dec3ce000';
const ALPHA_MAINTENANCE_CONFIG_URL = 'https://maintenance-alpha.pklotcorp.com/config.json';
const PROD_MAINTENANCE_CONFIG_URL = 'https://maintenance.autopass.xyz/config.json';

export const API_URL = isAlpha ? ALPHA_API_URL : PROD_API_URL;
export const AMPLITUDE_KEY = isAlpha ? ALPHA_AMPLITUDE_KEY : PROD_AMPLITUDE_KEY;
export const MAINTENANCE_CONFIG_URL = isAlpha ? ALPHA_MAINTENANCE_CONFIG_URL : PROD_MAINTENANCE_CONFIG_URL;

export const CUSTOMER_SERVICE_MAIL = 'cs@autopass.xyz';
export const LINE_LINK = '@189tbruf';

// 充電樁狀態
// - 等候插槍
export const WAITING_FOR_PLUG = 'WaitingForPlug';
// - 可充電
export const AVAILABLE = 'Available';
export const PREPARING = 'Preparing';
// - 充電中
export const WAITING = 'Waiting';
export const CHARGING = 'Charging';
export const FINISHING = 'Finishing';
export const SUSPEND_EVSE = 'SuspendedEVSE';
export const SUSPEND_EV = 'SuspendedEV';
// - 停用
export const UNAVAILABLE = 'Unavailable';
export const DISABLE = 'Disable';
export const UNKNOWN = 'unknown';
export const REMOVE = 'Remove';

// 充電狀態
// - 等待中
export const INIT = 'init';
export const INIT_AUTH = 'init_auth';
export const START_SESSION = 'start_session';
export const WAITING_CHARGING = 'waiting_charging';
// - 授權失敗
export const INTERRUPT = 'interrupt';
// - 連結槍逾時導致 session 開啟失敗
//    - stopReason: 'start_session_timeout', 'charging_no_energy'
export const START_SESSION_FAIL = 'start_session_fail';
// - 充電中
export const IN_CHARGING = 'charging';
// - 充電中 & 低電量
export const COMPLETE_CHARGING = 'complete_charging';
// - 強制結束充電，最後會改變為 `FORCE_STOP_CHARGING`
//   - stopReason: 'admin_force_stop', 'auth_amount_threshold', 'user_initiated'
export const COMPLETE_SESSION = 'complete_session';
// - 完成充電，為整個流程的最後一個步驟，已結帳完成
export const FINISH_CHARGING = 'finish_charging';
// - 完成充電(強制結束)，為整個流程的最後一個步驟，已結帳完成, 出現 stopReason
export const FORCE_STOP_CHARGING = 'force_stop_charging';

// 充電紀錄圖示
export const MENTOS_INIT = 'init';
export const MENTOS_LOADED = 'loaded';
export const MENTOS_READY = 'ready';
export const MENTOS_ANIMATE = 'animate';

export const STATE_GROUPS = {
  WAITING: [INIT, INIT_AUTH, START_SESSION, WAITING_CHARGING],
  CHARGING: [IN_CHARGING, COMPLETE_CHARGING],
  STOPPED: [COMPLETE_SESSION], // 已經結束充電，尚未結帳
  ENDED: [FINISH_CHARGING, FORCE_STOP_CHARGING], // 已經結束充電 && 已經結帳
  START_SESSION_FAIL: [START_SESSION_FAIL], // 啟動失敗 (120s 逾時 or 充電樁沒有供電 300s, 使用 `stop_reason` 區分)
};
